import { render, staticRenderFns } from "./userPostsList.vue?vue&type=template&id=9cc7c40e&"
import script from "./userPostsList.vue?vue&type=script&lang=js&"
export * from "./userPostsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports